import { Form } from 'antd';
import { useIntl } from 'react-intl';
import { DEFAULT_PAGINATION } from 'constants/common';
import { FilterForm } from 'components/form';
import { StyledSpace, StyledFormItem } from 'styles/overrides';
import { FromToDateSelector, BranchSelector } from 'components/selectors';
import { normalizeSearchData, normalizeSubmitSearchData } from 'utils/common';

export default function StatisticFilterSearch({ onSubmit, initialValues }) {
  const intl = useIntl();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit(
      normalizeSubmitSearchData({
        ...initialValues,
        ...values,
        page: DEFAULT_PAGINATION.PAGE,
      }),
    );
  };

  return (
    <FilterForm
      onFinish={handleSubmit}
      initialValues={normalizeSearchData(initialValues)}
      formInstance={form}
    >
      <StyledSpace size={16}>
        <StyledFormItem name="fromToDate">
          <FromToDateSelector allowClear format="DD/MM/YYYY" />
        </StyledFormItem>

        <StyledFormItem name="branch_id">
          <BranchSelector
            allowClear
            placeholder={intl.formatMessage({
              id: 'common.table.branches',
            })} />
        </StyledFormItem>
      </StyledSpace>
    </FilterForm>
  );
}
